<template>
<div class="chapter">
<div class="inner_page">
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_5"> </p>
<p class="block_35"><img alt="Image" class="calibre9" src="images/image-3.png"/></p>
<p class="block_5"> </p>
<p class="block_22"> </p>
<p class="block_36">From the beginning of time, secrets have been the advocates of darkness, stimulating the surreptitious thoughts of man.</p>
<p class="block_36">Barroth, E. M.1722.—All Things Woven—London, ENG</p>
<p class="block_37" id="calibre_pb_15"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_009.vue?692febcc